<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col class="image-box">
        <b-img :src="imageSrc" alt="Ribbon Image" class="w-100" fluid/>
        <div class="overlay-text col-10 offset-1" v-html="sanitizedText"></div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    text: String,
    image: Object
  },
  computed: {
    imageSrc() {
      return `/strapi/${this.image.data.attributes.url}`
    },
    sanitizedText() {
      return DOMPurify.sanitize(marked(this.text))
    }
  }
}
</script>

<style scoped src="@/assets/css/img-ribbon.css"/>
